import type { ModalTypeMap } from "@mui/base/Modal";
import Fade from "@mui/material/Fade";
import type { TransitionProps } from "@mui/material/transitions";
import React from "react";

import { DarkBackdrop, LightBackdrop } from "./backdrop";
import { StyledModal } from "./styles";

export type Props = ModalTypeMap["props"] & {
  backdropColor?: "dark" | "light";
  BackdropComponent?: React.FunctionComponent;
  fadeTimeout?: TransitionProps["timeout"];
};

export const Modal: React.FunctionComponent<Props> = ({
  backdropColor,
  BackdropComponent,
  children,
  fadeTimeout,
  ...props
}) => (
  <StyledModal
    {...props}
    closeAfterTransition
    slots={{
      backdrop: BackdropComponent ?? (backdropColor === "light" ? LightBackdrop : DarkBackdrop),
    }}
  >
    <Fade in={props.open} timeout={fadeTimeout ?? 300}>
      {children}
    </Fade>
  </StyledModal>
);

Modal.displayName = "Modal";
